module.exports = __webpack_public_path__ + "img/lv13.d0f24c81.png";